import { SET_UNLOCK_CHAINS } from '../actions/types';

const initialState = {
  chains: []
};

function unlockChain(state = initialState, action){
  switch(action.type){
    case SET_UNLOCK_CHAINS:
      return { ...state, chains: action.payload };
    default:
      return state;
  }
}

export default unlockChain;
